import React from 'react';
import { useField, useFormikContext } from 'formik';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from 'components/shadcn/ui/select';
import { Label } from 'components/shadcn/ui/label';
import { cn } from 'components/shadcn/lib/utils';
import { COUNTRIES } from './helpers';

export default function CountryDropdown({ label = 'Country', disabled }) {
    const [field, meta] = useField('address.country');
    const { setFieldValue, setFieldTouched } = useFormikContext();
    const errorOnSubmit = meta.error && meta.touched;

    const handleValueChange = (value) => {
        setFieldValue('address.country', value, false);
        setFieldTouched(field.name, true, false);
    };

    return (
        <div className="w-full space-y-1">
            {label && (
                <Label
                    htmlFor="address.country"
                    className={errorOnSubmit && 'text-red-500'}
                >
                    {label}
                </Label>
            )}
            <Select
                value={field.value || 'United States'}
                onValueChange={handleValueChange}
                disabled={disabled}
            >
                <SelectTrigger
                    className={cn(
                        'text-foreground data-[placeholder]:text-secondary-foreground',
                        errorOnSubmit && 'border-red-500'
                    )}
                >
                    <SelectValue placeholder="Select a country" />
                </SelectTrigger>
                <SelectContent>
                    {COUNTRIES.map((country) => (
                        <SelectItem
                            key={country}
                            value={country}
                            className="cursor-pointer text-foreground focus:bg-slate-100"
                        >
                            {country}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}
